<template>
  <gral-theme-three/>
</template>

<script>
import gralThemeThree from '../../../components/faq/general-theme-three'
export default {
  name: 'GeneralThemeThreeView',
  components: {
    gralThemeThree
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/faq/general-theme-three.view.vue